// Apart from blog.ts, which imports every post: a post importing these from there would
// read them before they are initialised.

/**
 * Where a post's `inlineCta`, `cards`, `downloads` and `letters` go, each on its own line in `body`, once. HTML
 * comments, so a marker left without its field renders nothing.
 */
export const INLINE_CTA = "\n\n<!-- listou -->\n\n";
export const CARDS = "\n\n<!-- cards -->\n\n";
export const DOWNLOADS = "\n\n<!-- downloads -->\n\n";
export const LETTERS = "\n\n<!-- letters -->\n\n";
export const BLOCK_MARKER = /\n\n<!-- (listou|cards|downloads|letters) -->\n\n/;
